<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card class="elevation-0">
        <v-card-title class="title">
          {{title}}
          <v-spacer></v-spacer>
          <v-btn fab small class="grey" @click.native="exit">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="loading !== true">
          <template>
            <tr  v-for="(report) in customer.customer">
              {{report.timestamp}} {{report.message}}
            </tr>
          </template>
        </v-card-text>
        <v-card-text v-if="loading !== true">

          {{ link }} <br><br>
        <button @click="copyUrl(link)" style="color: #1976d2;">Скопировать ссылку на профиль</button>

        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
  /* global Store */

  import { mapState, dispatch } from 'vuex'
  export default {
    data() {
      return {
        title: '',
        link: 'ddd',
      }
    },
    computed: {
      ...mapState('blacklist', {
        customer: 'customer',
        loading: 'loading',
        mode: 'mode',
        snackbar: 'snackbar',
        notice: 'notice',
      }),
    },
    methods: {
      exit () {
        this.$router.push('/blacklist')
      },
      closeSnackbar() {
        Store.commit("customers/setSnackbar", { snackbar: false });
        Store.commit("customers/setNotice", { notice: "" });
      },
    copyUrl() {
        const el = document.createElement('textarea');
        el.value = this.link;
        alert("Скопировано:\n" + this.link)
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
    }
    },
    created() {
      Store.dispatch('blacklist/getCustomerById', this.$route.params.id)
    },
    mounted() {
      if (this.$route.params.nick_name) {
        this.title = this.$route.params.nick_name
      } else {
        this.title = this.$route.params.id
      }
        this.link = this.$route.params.link
    }
  }
</script>




// WEBPACK FOOTER //
// BlackForm.vue?4a56b378